import { render, staticRenderFns } from "./Headliners.vue?vue&type=template&id=01d5289c&"
import script from "./Headliners.vue?vue&type=script&lang=js&"
export * from "./Headliners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports